import '../../assets/css/main.less'
import '../../assets/lib/boostrap/css/bootstrap.css';
import '../../assets/lib/boostrap/js/bootstrap';
import '../../assets/lib/fontawesome/css/font-awesome.min.css';
import './login.less';
import util from '../../assets/js/util';
import '../../assets/js/jquery.xdomainrequest.min'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import encryption from '../../assets/js/encryption';
import '../../assets/js/wxOpenLogin';
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
{
    let _this = this;
    let stateId = 0;
    let tab = $("#myTabs").find('a[id=home-tab]');
    if (window.location.href.indexOf('?') > '-1') {
        stateId = location.href.split('?')[1].split('=')[1].split('#')[0];
        for (let i = 0; i < tab.length; i++) {
            $(tab[i]).parent().removeClass('active')
        }
    }

    if (stateId == '1') {
        $($("#myTabs").find('a[name=1]').parent()).addClass('active')
    } else if (stateId == '2') {
        $($("#myTabs").find('a[name=2]').parent()).addClass('active')
    } else {

    }
    for (let i = 0; i < tab.length; i++) {
        $(tab[i]).on('click', () => {
            if ($(tab[i]).attr('name') == '1') {
                window.location.href = 'login.html?stateId=' + 1;
            } else if ($(tab[i]).attr('name') == '2') {
                window.location.href = 'login-yzm.html?stateId=' + 2;
            } else {

            }
        });
    }
    var AddressDid;

    (async () => {
        const fpPromise = await FingerprintJS.load();
        const result = await fpPromise.get();
        const { fonts, languages, audio, ...components } = result.components;
        const extendedComponents = {
            ...components,
            ip: { value: '172.0.0.1' },
        };
        const fingerprintId = FingerprintJS.hashComponents(extendedComponents);
        AddressDid = fingerprintId;
    })();
    function btnGo_onClick() {
        if (navigator.userAgent.toUpperCase().indexOf("SAFARI") !== -1) {
            $("#crmscontaier").css('display', 'block');
            $(".main-wrap").css('display', 'none');
        } else {
            var locator = new ActiveXObject("WbemScripting.SWbemLocator");
            var service = locator.ConnectServer(".");
            var properties = service.ExecQuery("SELECT * FROM Win32_NetworkAdapterConfiguration");
            var e = new Enumerator(properties);
            let MacAddressIp = [];
            for (; !e.atEnd(); e.moveNext()) {
                var p = e.item();
                if (p.MACAddress !== null) {
                    MacAddressIp.push(p.MACAddress)
                }
            }

            return MacAddressIp[0]
        }
    }

    var wechatLogin = document.getElementById("logBox");
    wechatLogin.onclick = function () {
        //$("#loginBox").attr("style", "display:block;");
        $("#loginBox").attr("style", "display:none;");
        $("#wxdl").attr("style", "display:block;");
        $("#wxdlqh").attr("style", "display:block;");
        var redirect_uri = "";
        if (SERVER.includes('ygdjonline.com')) {
            redirect_uri = "https://ygdjonline.com/wechatOpenPro/wxApiController/login";
        } else {
            redirect_uri = "https://ygdjonline.com/wechatOpenTest/ywxt_api/wxApiController/login";
        }
        top.wechatState = getUUID();
        var obj = new WxLogin({
            self_redirect: false,
            id: "logBox",
            appid: "wxe977fe89c04a2cc9",
            scope: "snsapi_login",
            redirect_uri: redirect_uri,
            state: top.wechatState,
            style: "black",
            href: ""
        });
//    	$.post(SERVER + '/wxApiController/wx_login', JSON.stringify(), (json) => {
//    		debugger;
//    		alert(111);
//    		window.location.href = json.data.
//    	})

    }

    function getUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    if (util.isMobile()) {
        alert('系统暂不能在手机上面访问')
    }
    if (util.getToken()) {
        window.location.replace('/index.html');
    }

    jQuery.ajaxSetup({
        accepts: {
            json: 'application/json'
        },
        beforeSend(xhr) {
            xhr.setRequestHeader('Token', util.getToken())
        },
        crossDomain: true,
        dataType: "text",
        contentType: 'application/json; charset=utf-8',
        dataFilter(json) {
            return json;
        }
    })

}
{
    let $userName = $("#userName");
    let $pwd = $("#pwd");
    let $formError = $("#form-error");
    let $errorText = $formError.find('.help-block');
    let $login = $("#login");
    let localUserName = localStorage.getItem('login.userName')
    if (localUserName) {
        $userName.val(localUserName);
    }

    function showError(message) {
        $errorText.html(' ' + message);
        $formError.show();
    }

    function hideError() {
        $formError.hide();
    }

    {
        $login.on('click', login);
        $pwd.on('keyup', function (e) {
            if (e.keyCode === 13) {
                login(e);
            }
        });

        function login(e) {
            if (util.isMobile()) {
                showError('系统暂不能在手机上面访问');
                return;
            }
            if ($login.prop('disabled')) {
                return;
            }
            let userName = $.trim($userName.val());
            let passwordVal = $.trim($pwd.val());
            if (!userName) {
                showError('请输入正确的账号');
                return;
            }

//            if (passwordVal.length < 6 || passwordVal.length > 12) {
//                showError('请输入6-12位密码');
//                return;
//            }
            let orignalPwd = passwordVal;
            passwordVal = encryption.desEnc(passwordVal, '&^%&%$&*&&^(*&)()(!@@@~LKJHLKfdkasd21383712', '0', '0');
            let AddressDids = encryption.desEnc(AddressDid, '&^%&%$&*&&^(*&)()(!@@@~LKJHLKfdkasd21383712', '0', '0');
            hideError();
            let data = {};
            data.password = passwordVal;
            data.mac = AddressDids;
            let da = {};
            da.loginname = userName;
            $login.prop('disabled', true);
            $.post(SERVER + '/rsa/getPublicKey',JSON.stringify(da),(res) => {
                userName = encryption.desEnc(userName, '&^%&%$&*&&^(*&)()(!@@@~LKJHLKfdkasd21383712', '0', '0');
                data.loginname = userName;
                if(res.status != 0){
                    showError(res.message);
                    return
                }
                const encrypt = new JSEncrypt()

                encrypt.setPublicKey(res.message)
// 加密
                let encrypted = encrypt.encrypt(passwordVal)
                data.password = encrypted;
                data.clientType= util.isMobile() ? "MOBILE" : "PC"
                $.post(SERVER + '/passPort/login', JSON.stringify(data), (json) => {
                    //$.post(SERVER + '/passPort/login?loginname='+userName+'&password='+passwordVal+'&mac='+AddressDids, (json) => {
                    if (json.status === 0) {
                        //新的密码规则校验
                        if (!util.PasswordStrength(orignalPwd)) {
                            showError('密码强度弱，请登录系统后，先进行密码修改');
                            if ($("input[type='checkbox']").is(':checked')) {
                                localStorage.setItem('login.userName', $.trim($userName.val()));
                            }
                            setTimeout(function () {
                                window.location.replace( '/change-password.html?passwordStrengthFlag=0&token=?' + json.data.token);
                            }, 1000)
                        } else {
                            util.saveToken(json.data.token)
                            if ($("input[type='checkbox']").is(':checked')) {
                                localStorage.setItem('login.userName', $.trim($userName.val()));
                            }
                            window.location.replace('/index.html');
                        }
                    } else {
                        $login.prop('disabled', false);
                        if (json.message != 'macinvalid') {
                            showError(json.message);
                        } else {
                            showError('您的设备(' + AddressDid + ')未在安全范围，请联系管理员！');
                        }
                    }
                }, 'json')

            },'json')




        }
    }
}
